/** `useDocMeta` (1.I-3 deliverable 10): one `docs.meta` read under `['documents', 'meta', id]`. */
import { docsMeta, settingsGet } from '@codex/contracts';
import { useQuery } from '@tanstack/react-query';
import { api } from '../auth/client.js';

export const docMetaKey = (docId: string) => ['documents', 'meta', docId] as const;
export const settingsKey = ['settings'] as const;

export function useDocMeta(docId: string) {
  return useQuery({
    queryKey: docMetaKey(docId),
    queryFn: () => api(docsMeta, { params: { id: docId } }),
    retry: false,
  });
}

/** `settings.get`, one query for every reader of a setting. */
export function useSettings() {
  return useQuery({ queryKey: settingsKey, queryFn: () => api(settingsGet), retry: false });
}
